import { Routes } from '@angular/router';
import { contentItemResolver } from '@content/content-item.resolver';
import { contentNewsItemsResolver } from '@content/content-news-items.resolver';
import { TabsPage } from '@tabs/tabs.page';

const contentRoutes: Routes = [
  {
    path: 'content',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@content/content-list.page').then(m => m.ContentListPage),
        resolve: { contentItems: contentNewsItemsResolver },
        data: {
          showContentItemDate: true,
          largeItem: true,
          showSearch: true,
        },
      },
      {
        path: ':uuid',
        loadComponent: () =>
          import('@content/content-item.page').then(m => m.ContentItemPage),
        resolve: { contentItem: contentItemResolver },
      },
    ],
  },
];

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/ad6/start',
    pathMatch: 'full',
  },
  {
    path: 'ad6',
    component: TabsPage,
    children: [
      {
        path: 'start',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('@start/start.page').then(m => m.StartPage),
          },
          {
            path: 'content/:uuid',
            loadComponent: () =>
              import('@content/content-item.page').then(m => m.ContentItemPage),
            resolve: { contentItem: contentItemResolver },
          },
          {
            path: 'about',
            loadComponent: () =>
              import('@about/about.page').then(m => m.AboutPage),
          },
          {
            path: 'notifications',
            loadComponent: () =>
              import('@notification/notification-list.page').then(
                m => m.NotificationListPage,
              ),
          },
        ],
      },
      ...contentRoutes,
      {
        path: 'live',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('@live/live.page').then(m => m.LivePage),
          },
        ],
      },
      {
        path: 'photos',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('@photo/photo-album-list.page').then(
                m => m.PhotoAlbumListPage,
              ),
          },
          {
            path: ':uuid',
            loadComponent: () =>
              import('@photo/photo-album-detail.page').then(
                m => m.PhotoAlbumDetailPage,
              ),
          },
        ],
      },
      {
        path: 'information',
        loadChildren: () =>
          import('@information/information.routes').then(m => m.routes),
      },
    ],
  },
];
